// ItemTypes.ts
export const ItemTypes = {
    TASK: 'task',
  };
  